// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__o7G0u","file":"styles_file__eJ1h2"};